jQuery($ => {
    class MychartWidget {
      constructor(element) {
        this._         = element;
        this._element  = $(element);
        this._select   = this._element.find('[name="additionalparams"]');
        this._template = this._element.find('#mychart').clone();
  
        this.init();
      }
  
      //≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡
      // ✅ Initialize
      //≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡
  
      init() {
        this.setupHandlers();
        this._element.trigger( 'init', this );
      }
  
      //≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡
      // ✅ Setup Handlers
      //≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡
  
      setupHandlers() {
        this._select.on('change', this.handleParametersChange.bind(this));
      }

      handleParametersChange(event) {
        const additionalparams = event.target.value;

        const dept   = additionalparams.split('|')[0];
        const vt     = additionalparams.split('|')[1];
        const custom = additionalparams.split('|')[2];
        
        $('#mychart').replaceWith(this._template.clone());

        if ( dept && vt ) {
          $('#mychart').empty();
          if ( custom ) {
            $('#mychart').append('<iframe src="' +`${MYCHART.url}/${custom}`+ '" width="100%" height="850" frameborder="0" sandbox="allow-scripts allow-popups allow-same-origin"></iframe>');
          } else {
            mychartWidget.renderWidget({
              "containerId"     : "mychart",
              "url"             : MYCHART.url,
              "apiKey"          : MYCHART.api_key,
              "widgetType"      : MYCHART.widget_type,
              "additionalParams": {
                "dept": dept,
                "vt"  : vt,
              }
            });
          }
        }
      }
    }
  
    //≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡
    // ✅ Setup jQuery Plugin
    //≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡
  
    $.fn.mychart_widget = function() {
      var _ = this,
          opt = arguments[0],
          args = Array.prototype.slice.call(arguments, 1),
          l = _.length,
          i,
          ret;
      for (i = 0; i < l; i++) {
        if (typeof opt == 'object' || typeof opt == 'undefined')
          _[i].mychart_widget = new MychartWidget(_[i], opt);
        else
          ret = _[i].mychart_widget[opt].apply(_[i].mychart_widget, args);
        if (typeof ret != 'undefined') return ret;
      }
      return _;
    }
  
    //≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡
    // ✅ Run
    //≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡
  
    $('.o-mychart-widget').mychart_widget();
});